// TOOD: 3d rotation update before blendet in
import AdvancedController from "./advanced-controller"
import { gsap } from 'gsap'
import Hunt from 'huntjs';

const TRANSITION_DURATION_MS = 0.5
const AUTO_SLIDE_TIME = 8 * 1000
const CONTRAIN = 800;

const ANIM_BREAKPOINT_PX = 768
const SWIPE_FORCE_THRESHOLD = 0.5

export default class TabbedHighlightsController extends AdvancedController {

  static targets = [
    'tab',
    'highlight',
    'container',
    'image',
    'background',
    'glass',
    'progress'
  ];

  static values = {
    active: {
      type: Number,
      default: 0
    },
    length: Number,
    inTransition: {
      type: Boolean,
      default: false
    },
    isPaused: {
      type: Boolean,
      default: true
    }
  }

  connect() {
    super.connect();
    this.restartTimer(0);
    this.lastFrameTime = (new Date).getTime();
    requestAnimationFrame(this.update.bind(this))

    new Hunt(this.element, {
      persist: true,
      leave: this.onLeaveViewport.bind(this),
      enter: this.onEnterViewport.bind(this)
    });

    document.addEventListener("mousemove", this.onMouseMove.bind(this))
    document.addEventListener("touchstart", this.onTouchStart.bind(this))
    document.addEventListener("touchend", this.onTouchEnd.bind(this))
  }

  onTouchStart(e) {
    this.touchStartX = e.touches[0].clientX
    this.touchStartTime = (new Date).getTime();
  }

  onTouchEnd(e) {
    const deltaTime = this.touchStartTime - (new Date).getTime()
    const deltaX = e.changedTouches[0].clientX - this.touchStartX
    const speed = deltaX / deltaTime
    if (Math.abs(speed) >= SWIPE_FORCE_THRESHOLD) {
      let newActive = (this.activeValue + (speed < 0 ? -1 : 1)) % this.lengthValue
      if (newActive < 0) {
        newActive = this.lengthValue - 1
      }
      this.setActive({ params: { active: newActive } })
    }
  }

  onEnterViewport() {
    this.isPausedValue = false
    if (this.timerTimeline) this.timerTimeline.resume()
  }

  onLeaveViewport() {
    this.isPausedValue = true
    if (this.timerTimeline) this.timerTimeline.pause()
  }

  transforms(x, y, el) {
    let box = el.getBoundingClientRect();
    let calcX = -(y - box.y - (box.height / 2)) / CONTRAIN;
    let calcY = (x - box.x - (box.width / 2)) / CONTRAIN;

    return "perspective(100px) "
      + "   rotateX(" + calcX + "deg) "
      + "   rotateY(" + calcY + "deg) ";
  };

  transformElement(el, xyEl) {
    el.style.transform = this.transforms.apply(null, xyEl);
  }

  onMouseMove(e) {
    if (this.imageTargets) {
      let xy = [e.clientX, e.clientY];
      const targetEl = this.imageTargets[this.activeValue].querySelector("img");
      let position = xy.concat([targetEl]);
      window.requestAnimationFrame(() => {
        this.transformElement(targetEl, position);
      });
    }
  }

  // @params e - example: { params: { active: <num> } }, given by stimulus
  setActive(e) {
    if (this.activeValue !== e.params.active && !this.inTransitionValue) {
      // start the transition
      this.inTransitionValue = true;
      // store prev-active and active
      const prevActive = this.activeValue;
      const active = e.params.active;
      // preserve the current container height as min height, as else the 
      // container would collapse and everything would jump
      this.containerTarget.style.minHeight = `${this.containerTarget.offsetHeight}px`
      // immediatelly change the tab
      this.changeTab(prevActive, active)
      // determine the direction
      const direction = active > this.activeValue ? "-" : "+"
      // fade out the prevActive ...
      this.fadeOutAnimation(prevActive, direction, () => {
        this.activeValue = active;
        // ... then fade in the active
        this.fadeInAnimation(this.activeValue, () => {
          // ... then restart the timer (progress bar)
          this.restartTimer(this.activeValue)
          // end the transition
          this.inTransitionValue = false;
        });
      })
    }
  }

  fadeOutAnimation(index, direction, done) {
    // move left and fade out
    gsap.fromTo(this.highlightTargets[index], {
      x: "0",
      opacity: "1"
    }, {
      x: `${direction}33.33%`,
      opacity: "0",
      duration: TRANSITION_DURATION_MS,
      onComplete: () => {
        this.highlightTargets[index].classList.remove('-active')
        this.highlightTargets[index].classList.add('-inactive')
        done()
      }
    });
  }

  fadeInAnimation(index, done) {

    this.highlightTargets[index].classList.add('-active')
    this.highlightTargets[index].classList.remove('-inactive')

    // calculate the new container height
    const currentContainerHeight = parseInt(this.containerTarget.style.minHeight, 10);
    this.containerTarget.style.minHeight = 'auto';
    this.containerTarget.style.height = 'auto';

    const newContainerHeight = this.containerTarget.offsetHeight;

    gsap.fromTo(this.containerTarget, {
      height: `${currentContainerHeight}px`
    }, {
      height: `${newContainerHeight}px`,
      duration: TRANSITION_DURATION_MS / 2
    })

    // animate the fade in animation
    gsap.timeline({
      // onComplete: () => {
      //   done();
      // }
    })
      // reset opacity, scale and x value (changed by fade out animation)
      .set(this.highlightTargets[index], {
        opacity: 1,
        x: "0%",
        scale: 1
      })
      // image: fadeInTop
      .fromTo(this.imageTargets[index], {
        opacity: "0",
        x: "0%",
        y: "-=50%"
      }, {
        opacity: "1",
        y: "0%",
        duration: TRANSITION_DURATION_MS,
      })
      // background: slideInRight
      .fromTo(this.backgroundTargets[index], {
        left: "calc( 100% + 3rem )"
      },
        {
          left: "calc( 0% + 0rem )",
          duration: TRANSITION_DURATION_MS,
          ease: "elastic.out(1, 1)",
        }, TRANSITION_DURATION_MS / 2)
      // glass: zoomIn
      .fromTo(this.glassTargets[index], {
        transformOrigin: "center",
        scale: 0
      }, {
        scale: 1,
        duration: TRANSITION_DURATION_MS,
        ease: "elastic.out(1, 1)",
      })
      // glass: slideLeft
      .fromTo(this.glassTargets[index], {
        x: "0rem"
      }, {
        x: window.innerWidth >= ANIM_BREAKPOINT_PX ? "-5rem" : "0rem",
        duration: TRANSITION_DURATION_MS,
        onComplete: done
      })
      // ball: slideLeft
      .to(this.imageTargets[this.activeValue], {
        // scale: 1.1,
        x: window.innerWidth >= ANIM_BREAKPOINT_PX ? "-=10%" : "+=0%",
        duration: AUTO_SLIDE_TIME / 1000 / 2,
        ease: "Power2.easeOut"
      }, "-=0.3")
  }

  restartTimer(index) {
    this.timer = 0

    this.timerTimeline = gsap.timeline()
      .fromTo(this.progressTargets[index], {
        width: "0%"
      },
        {
          width: "100%",
          duration: AUTO_SLIDE_TIME / 1000,
          ease: 'linear'
        })
  }

  changeTab(prevIndex, activeIndex) {
    this.tabTargets[prevIndex].classList.remove('-active')
    this.tabTargets[activeIndex].classList.add('-active')
    this.progressTargets[activeIndex].style.width = "0%"
  }

  update() {
    if (!this.inTransitionValue && !this.isPausedValue) {
      // const duration = (new Date).getTime() - this.timer

      const delta = (new Date).getTime() - this.lastFrameTime;
      this.timer += delta

      if (this.timer >= AUTO_SLIDE_TIME) {
        const newActive = (this.activeValue + 1) % this.lengthValue
        this.setActive({ params: { active: newActive } })
      }
    }
    this.lastFrameTime = (new Date).getTime();
    requestAnimationFrame(this.update.bind(this))
  }

}
